<template lang="pug">
div
  v-app-bar.main-header-mobile.secondary.elevation-0(height="106px")
    v-container.d-flex.justify-space-between.h-100
      router-link.d-block(to="/")
        img.main-header-logo.py-1(:src="logo", contain)
      v-spacer
      .d-flex.flex-column-reverse.flex-sm-row.justify-center.align-center.main-header-menu.my-auto
        template(v-if="informations.services_link")
          a.text-body-1.font-weight-bold.primary--text.text-decoration-none.d-flex(
            :href="informations.services_link",
            target="_blank",
          )
            v-icon(color="primary") fas fa-tools
            v-btn.ml-1.font-weight-bold.primary-text(text, depressed, rounded) SERVIÇOS
          
          v-divider.ml-6.mr-3(v-if="!xs", vertical)
        grid-container.justify-start.mb-2.mb-sm-0(
          auto-flow="column",
          gap="8px"
        )
          tooltip(v-for="(s, i) in social", :key="i", :tip="s.title", bottom)
            v-btn(
              :href="s.link",
              color="primary",
              target="_blank",
              icon,
              depressed,
              height="40px",
              width="40px"
            )
              v-icon {{ s.icon }}
</template>

<script>
import Tooltip from "../tools/Tooltip.vue";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    logo() {
      return this.files + this.informations.img;
    },
    social() {
      return [
        {
          title: "Facebook",
          link: this.informations.facebook,
          icon: "fab fa-facebook-f",
        },
        {
          title: "Instagram",
          link: this.informations.instagram,
          icon: "fab fa-instagram",
        },
      ];
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  components: {
    Tooltip,
  },
};
</script>

<style>
.primary-text {
  color: #264355 !important;
}
.main-header-logo {
  height: 100%;
  max-width: 114px;
}
.main-header-menu {
  height: 32px;
}
</style>
